import { formatDistanceStrict } from 'date-fns';

/**
 * Get distance between 2 dates in human-readable format
 *
 * @param {string} start - The start date ISOString
 * @param {string} end - The end date ISOString
 * @returns {string} - The duration in a human-readable format
 */
export const computeToDuration = (start, end) => {
    return formatDistanceStrict(new Date(start), new Date(end));
};
